<template>
  <div class="settings-page admin-page">
    <header class="admin-page__header">
      <div class="admin-page__title">
        <h2>系统设置</h2>
        <p>支付汇率、域名服务商接入与业务参数</p>
      </div>
    </header>

    <a-alert
      type="info"
      show-icon
      class="settings-note"
      message="显示当前【生效配置】：优先取数据库，未在数据库设置的则取后端配置文件 config/app.php。保存后写入数据库并覆盖文件值；密钥类只显示是否已配置，留空表示保持原值。"
    />

    <a-card :bordered="false" class="admin-card settings-card">
      <div class="settings-section">
        <div class="settings-section__head">
          <h3>支付 / 汇率</h3>
          <p>UPay 支付通道与人民币结算汇率</p>
        </div>
        <a-form layout="horizontal" :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }">
          <a-form-item label="UPay endpoint">
            <a-input v-model="kv['upay.endpoint']" placeholder="https://..." />
            <a-tag v-if="srcLabel('upay.endpoint')" class="src-tag" :color="meta['upay.endpoint'] && meta['upay.endpoint'].source==='db' ? 'blue' : 'orange'">{{ srcLabel('upay.endpoint') }}</a-tag>
          </a-form-item>
          <a-form-item label="UPay key">
            <a-input-password
              v-model="kv['upay.key']"
              :placeholder="secretPh('upay.key')"
            />
            <a-tag v-if="srcLabel('upay.key')" class="src-tag" :color="meta['upay.key'] && meta['upay.key'].source==='db' ? 'blue' : 'orange'">{{ srcLabel('upay.key') }}</a-tag>
          </a-form-item>
          <a-form-item label="CNY 汇率">
            <a-input v-model="kv['upay.cny_rate']" />
            <a-tag v-if="srcLabel('upay.cny_rate')" class="src-tag" :color="meta['upay.cny_rate'] && meta['upay.cny_rate'].source==='db' ? 'blue' : 'orange'">{{ srcLabel('upay.cny_rate') }}</a-tag>
          </a-form-item>
        </a-form>
      </div>

      <a-divider />

      <div class="settings-section">
        <div class="settings-section__head">
          <h3>域名服务商</h3>
          <p>NameSilo 注册商 + Cloudflare DNS 接入凭证</p>
        </div>
        <a-form layout="horizontal" :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }">
          <a-form-item label="NameSilo API key">
            <a-input-password v-model="kv['namesilo.api_key']" :placeholder="secretPh('namesilo.api_key')" />
            <a-tag v-if="srcLabel('namesilo.api_key')" class="src-tag" :color="meta['namesilo.api_key'] && meta['namesilo.api_key'].source==='db' ? 'blue' : 'orange'">{{ srcLabel('namesilo.api_key') }}</a-tag>
          </a-form-item>
          <a-form-item label="NameSilo sandbox">
            <a-input v-model="kv['namesilo.sandbox']" placeholder="1 = sandbox, 0 = prod" />
            <a-tag v-if="srcLabel('namesilo.sandbox')" class="src-tag" :color="meta['namesilo.sandbox'] && meta['namesilo.sandbox'].source==='db' ? 'blue' : 'orange'">{{ srcLabel('namesilo.sandbox') }}</a-tag>
          </a-form-item>
          <a-form-item label="Cloudflare API token / Key">
            <a-input-password v-model="kv['cf.api_token']" :placeholder="secretPh('cf.api_token')" />
            <a-tag v-if="srcLabel('cf.api_token')" class="src-tag" :color="meta['cf.api_token'] && meta['cf.api_token'].source==='db' ? 'blue' : 'orange'">{{ srcLabel('cf.api_token') }}</a-tag>
            <div style="color:#999;font-size:12px;margin-top:4px;line-height:1.5;">API Token(推荐)：只填此项，邮箱留空。Global API Key：此处填 Key，并在下方「API Email」填账户邮箱。</div>
          </a-form-item>
          <a-form-item label="Cloudflare API Email（用 Global API Key 时必填）">
            <a-input v-model="kv['cf.api_email']" placeholder="Global API Key 对应的账户邮箱；用 API Token 时留空" />
            <a-tag v-if="srcLabel('cf.api_email')" class="src-tag" :color="meta['cf.api_email'] && meta['cf.api_email'].source==='db' ? 'blue' : 'orange'">{{ srcLabel('cf.api_email') }}</a-tag>
          </a-form-item>
          <a-form-item label="Cloudflare account_id">
            <a-input v-model="kv['cf.account_id']" />
            <a-tag v-if="srcLabel('cf.account_id')" class="src-tag" :color="meta['cf.account_id'] && meta['cf.account_id'].source==='db' ? 'blue' : 'orange'">{{ srcLabel('cf.account_id') }}</a-tag>
          </a-form-item>
          <a-form-item label="宝塔面板 URL">
            <a-input v-model="kv['bt.panel_url']" placeholder="https://your-server:8888 （末尾不带 /）" />
            <a-tag v-if="srcLabel('bt.panel_url')" class="src-tag" :color="meta['bt.panel_url'] && meta['bt.panel_url'].source==='db' ? 'blue' : 'orange'">{{ srcLabel('bt.panel_url') }}</a-tag>
          </a-form-item>
          <a-form-item label="宝塔 API key">
            <a-input-password v-model="kv['bt.api_key']" :placeholder="secretPh('bt.api_key')" />
            <a-tag v-if="srcLabel('bt.api_key')" class="src-tag" :color="meta['bt.api_key'] && meta['bt.api_key'].source==='db' ? 'blue' : 'orange'">{{ srcLabel('bt.api_key') }}</a-tag>
          </a-form-item>
        </a-form>
      </div>

      <a-divider />

      <div class="settings-section">
        <div class="settings-section__head">
          <h3>域名健康检测</h3>
          <p>VirusTotal API（用于域名「健康度」面板的 VT 标红检查）</p>
        </div>
        <a-form layout="horizontal" :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }">
          <a-form-item label="VirusTotal API key">
            <a-input-password v-model="kv['vt.api_key']" :placeholder="secretPh('vt.api_key')" />
            <a-tag v-if="srcLabel('vt.api_key')" class="src-tag" :color="meta['vt.api_key'] && meta['vt.api_key'].source==='db' ? 'blue' : 'orange'">{{ srcLabel('vt.api_key') }}</a-tag>
            <div style="color:#999;font-size:12px;margin-top:4px;line-height:1.5;">下方「VT 代理」若填了地址，则优先走自建多 key 聚合代理，此处官方 key 可留空。</div>
          </a-form-item>
          <a-form-item label="VT 代理地址（自建多key聚合，选填）">
            <a-input v-model="kv['vt.proxy_url']" placeholder="如 https://vt.iiil.me/api/v1；留空则用上面的官方 VT" />
            <a-tag v-if="srcLabel('vt.proxy_url')" class="src-tag" :color="meta['vt.proxy_url'] && meta['vt.proxy_url'].source==='db' ? 'blue' : 'orange'">{{ srcLabel('vt.proxy_url') }}</a-tag>
          </a-form-item>
          <a-form-item label="VT 代理 Token（X-API-Token）">
            <a-input-password v-model="kv['vt.proxy_token']" :placeholder="secretPh('vt.proxy_token')" />
            <a-tag v-if="srcLabel('vt.proxy_token')" class="src-tag" :color="meta['vt.proxy_token'] && meta['vt.proxy_token'].source==='db' ? 'blue' : 'orange'">{{ srcLabel('vt.proxy_token') }}</a-tag>
          </a-form-item>
          <p style="margin-top:16px;">插件接入（客户端「API接管」页展示，改了即时生效，无需重打包）</p>
          <a-form-item label="插件安装命令">
            <a-input v-model="kv['plugin.install_cmd']" placeholder="如 wget -O install.sh https://xxx/install.sh && bash install.sh" />
            <a-tag v-if="srcLabel('plugin.install_cmd')" class="src-tag" :color="meta['plugin.install_cmd'] && meta['plugin.install_cmd'].source==='db' ? 'blue' : 'orange'">{{ srcLabel('plugin.install_cmd') }}</a-tag>
          </a-form-item>
          <a-form-item label="插件下载地址">
            <a-input v-model="kv['plugin.plugin_url']" placeholder="如 https://xxx/plugin/oliver_panel_assistant.zip" />
            <a-tag v-if="srcLabel('plugin.plugin_url')" class="src-tag" :color="meta['plugin.plugin_url'] && meta['plugin.plugin_url'].source==='db' ? 'blue' : 'orange'">{{ srcLabel('plugin.plugin_url') }}</a-tag>
          </a-form-item>
        </a-form>
      </div>

      <a-divider />

      <div class="settings-section">
        <div class="settings-section__head">
          <h3>业务参数</h3>
          <p>BYO 额度、充值预设与默认注册年限</p>
        </div>
        <a-form layout="horizontal" :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }">
          <a-form-item label="BYO 额外额度单价 (U)">
            <a-input v-model="kv['byo.extra_slot_price_u']" />
            <a-tag v-if="srcLabel('byo.extra_slot_price_u')" class="src-tag" :color="meta['byo.extra_slot_price_u'] && meta['byo.extra_slot_price_u'].source==='db' ? 'blue' : 'orange'">{{ srcLabel('byo.extra_slot_price_u') }}</a-tag>
          </a-form-item>
          <a-form-item label="BYO 单次最多购买数">
            <a-input v-model="kv['byo.max_buy_per_order']" />
            <a-tag v-if="srcLabel('byo.max_buy_per_order')" class="src-tag" :color="meta['byo.max_buy_per_order'] && meta['byo.max_buy_per_order'].source==='db' ? 'blue' : 'orange'">{{ srcLabel('byo.max_buy_per_order') }}</a-tag>
          </a-form-item>
          <a-form-item label="充值预设金额">
            <a-input
              v-model="kv['recharge.preset_amounts']"
              placeholder="逗号分隔, 如 10,50,100"
            />
            <a-tag v-if="srcLabel('recharge.preset_amounts')" class="src-tag" :color="meta['recharge.preset_amounts'] && meta['recharge.preset_amounts'].source==='db' ? 'blue' : 'orange'">{{ srcLabel('recharge.preset_amounts') }}</a-tag>
          </a-form-item>
          <a-form-item label="充值最小金额 (U)">
            <a-input v-model="kv['recharge.min_u']" />
            <a-tag v-if="srcLabel('recharge.min_u')" class="src-tag" :color="meta['recharge.min_u'] && meta['recharge.min_u'].source==='db' ? 'blue' : 'orange'">{{ srcLabel('recharge.min_u') }}</a-tag>
          </a-form-item>
          <a-form-item label="默认域名注册年限">
            <a-input v-model="kv['default_domain_years']" />
            <a-tag v-if="srcLabel('default_domain_years')" class="src-tag" :color="meta['default_domain_years'] && meta['default_domain_years'].source==='db' ? 'blue' : 'orange'">{{ srcLabel('default_domain_years') }}</a-tag>
          </a-form-item>
        </a-form>
      </div>
    </a-card>

    <a-affix :offset-bottom="0">
      <div class="settings-savebar">
        <span class="settings-savebar__hint">
          <a-icon type="info-circle" />
          带星号字段为加密存储,留空表示保持原值不变
        </span>
        <a-button type="primary" size="large" @click="onSave" :loading="saving">
          保存所有改动
        </a-button>
      </div>
    </a-affix>
  </div>
</template>

<script>
import { listSettings, saveSettings } from '@/api/settings';

const KEYS = [
  'upay.endpoint',
  'upay.key',
  'upay.cny_rate',
  'namesilo.api_key',
  'namesilo.sandbox',
  'cf.api_token',
  'cf.api_email',
  'cf.account_id',
  'bt.panel_url',
  'bt.api_key',
  'vt.api_key',
  'vt.proxy_url',
  'vt.proxy_token',
  'plugin.install_cmd',
  'plugin.plugin_url',
  'byo.extra_slot_price_u',
  'byo.max_buy_per_order',
  'recharge.preset_amounts',
  'recharge.min_u',
  'default_domain_years',
];

const ENCRYPTED_KEYS = ['upay.key', 'namesilo.api_key', 'cf.api_token', 'bt.api_key', 'vt.api_key', 'vt.proxy_token'];

function emptyKv() {
  const o = {};
  KEYS.forEach(k => (o[k] = ''));
  return o;
}

export default {
  data() {
    return {
      saving: false,
      kv: emptyKv(),
      meta: {}, // { [k]: { has_value, source } } —— 用于密钥「已配置」提示与来源标注
    };
  },
  mounted() {
    listSettings()
      .then(res => {
        const m = {};
        (res.data || []).forEach(r => {
          m[r.k] = { has_value: !!r.has_value, source: r.source || '' };
          if (KEYS.includes(r.k)) {
            this.kv[r.k] = ENCRYPTED_KEYS.includes(r.k) ? '' : (r.v == null ? '' : r.v);
          }
        });
        this.meta = m;
      })
      .catch(e => this.$message.error((e && e.data && e.data.message) || '加载失败'));
  },
  methods: {
    // 密钥字段占位：已配置则提示留空保留，否则提示未配置
    secretPh(k) {
      return this.meta[k] && this.meta[k].has_value ? '已配置 · 留空保留原值' : '未配置';
    },
    // 配置来源标签：db=数据库 file=配置文件
    srcLabel(k) {
      const s = this.meta[k] && this.meta[k].source;
      return s === 'db' ? '数据库' : s === 'file' ? '配置文件' : '';
    },
    onSave() {
      this.saving = true;
      const items = Object.entries(this.kv)
        .filter(([k, v]) => {
          if (ENCRYPTED_KEYS.includes(k) && (v === '' || v == null)) return false;
          return true;
        })
        .map(([k, v]) => ({ k, v }));
      saveSettings(items)
        .then(() => this.$message.success('保存成功'))
        .catch(e => this.$message.error((e && e.data && e.data.message) || '保存失败'))
        .finally(() => (this.saving = false));
    },
  },
};
</script>

<style scoped>
.settings-note {
  margin-bottom: 16px;
  border-radius: 8px;
}
.src-tag {
  display: inline-block;
  margin-top: 6px;
  font-size: 12px;
}
</style>